import { getBrand } from '../utils/getBrand';

export const updateVaStyleHref = () => {
  const brandForCdk = getBrand().name === 'shaw' ? 'rogers' : getBrand().name;
  const linkElement = document.querySelector('#va-element-style');
  (<HTMLLinkElement>linkElement).href = `va-styles-${brandForCdk}.css`;
};
